// extracted by mini-css-extract-plugin
module.exports = {"prescription-customer-skeleton":"prescriptionCustomerSkeletons_prescription-customer-skeleton__FERZ8"};